export { GetLocationsQuery } from './get-locations';
export { GetRegionsQuery } from './get-regions';
export { GetStudentSchoolClassesQuery } from './get-student-school-classes';
export { GetSchoolNumbersQuery } from './get-school-numbers';
export { GetSchoolTypesQuery } from './get-school-types';
